import { render, staticRenderFns } from "./MuestrasTabAnalisis.vue?vue&type=template&id=0fad6743"
import script from "./MuestrasTabAnalisis.vue?vue&type=script&lang=js"
export * from "./MuestrasTabAnalisis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports